import { Field, useFormikContext } from 'formik';
import React from 'react';
import { Link } from 'react-router-dom';
import { Checkbox, Fieldset, Select, Subsection } from '@fourthwall/components';
import { routing } from '@utils/routing';
import * as S from './AccountNotifications.styled';
export const AccountNotifications = () => {
    const { values, setFieldValue } = useFormikContext();
    return (React.createElement(Subsection, { title: "Account notifications" },
        React.createElement("div", { style: { marginBottom: 16 } },
            React.createElement("p", null, "You may still receive occasional personalized emails from our team based on your account status.")),
        React.createElement(Fieldset, null,
            React.createElement(Fieldset.Row, null,
                React.createElement(Fieldset.Item, null,
                    React.createElement(Checkbox, { value: values.newOrder !== 'NEVER', onValueChange: (value) => {
                            if (value === false) {
                                setFieldValue('newOrder', 'NEVER');
                            }
                            else {
                                setFieldValue('newOrder', 'DAILY');
                            }
                        }, label: "New orders received", description: "Notify me about new orders or donations" }),
                    values.newOrder !== 'NEVER' && (React.createElement(Fieldset.Row, { inner: true },
                        React.createElement(S.SelectWrapper, null,
                            React.createElement(Fieldset.Item, null,
                                React.createElement(Field, { component: Select, name: 'newOrder', options: [
                                        { value: 'DAILY', label: 'Daily' },
                                        { value: 'INSTANT', label: 'Instant' },
                                    ], label: "Notification frequency" }))))))),
            React.createElement(Fieldset.Row, null,
                React.createElement(Fieldset.Item, null,
                    React.createElement(Field, { component: Checkbox, name: 'offerVariantStatusUpdates', label: "Fourthwall-manufactured products going out of stock", description: "Notify me when a Fourthwall-manufactured product goes out of stock" }))),
            React.createElement(Fieldset.Row, null,
                React.createElement(Fieldset.Item, null,
                    React.createElement(Field, { component: Checkbox, name: 'paymentMethodCharges', label: "Payment method charges", description: React.createElement(React.Fragment, null,
                            "Notify me when my",
                            ' ',
                            React.createElement(Link, { to: routing.settings.billing.self, target: "_blank" }, "payment method"),
                            ' ',
                            "is charged") }))),
            React.createElement(Fieldset.Row, null,
                React.createElement(Fieldset.Item, null,
                    React.createElement(Field, { component: Checkbox, name: 'monthlyChargeLimitReached', label: "Monthly charge limit reached", description: React.createElement(React.Fragment, null,
                            "Notify me when my",
                            ' ',
                            React.createElement(Link, { to: routing.settings.billing.self, target: "_blank" }, "monthly charge limit"),
                            ' ',
                            "is reached") }))),
            React.createElement(Fieldset.Row, null,
                React.createElement(Fieldset.Item, null,
                    React.createElement(Field, { component: Checkbox, name: 'blockedTransactions', label: "Blocked transactions", description: React.createElement(React.Fragment, null,
                            "Notify me when a",
                            ' ',
                            React.createElement(Link, { to: routing.blockedTransactions, target: "_blank" }, "transaction is blocked")) }))),
            React.createElement(Fieldset.Row, null,
                React.createElement(Fieldset.Item, null,
                    React.createElement(Field, { component: Checkbox, name: 'twitchGiftingSummaries', label: "Twitch gifting summaries", description: React.createElement(React.Fragment, null,
                            "Send me a summary of recent",
                            ' ',
                            React.createElement(Link, { to: routing.contributions.orders.giveaways.all, target: "_blank" }, "Twitch gifts"),
                            ' ',
                            "(including a clip of the giveaway)") }))))));
};
